export const SELECT_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA =
  'SELECT_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA';
export const SELECT_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA_ATTRIBUTE =
  'potentialCreditProfileContainer';
export const RESET_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA =
  'RESET_POTENTIAL_CREDIT_PROFILE_CONTAINER_DATA';
